/*
 * © Copyright 2014 - 2022 Micro Focus or one of its affiliates.
 *
 * The only warranties for products and services of Micro Focus and its affiliates and licensors ("Micro Focus") are as
 * may be set forth in the express warranty statements accompanying such products and services. Nothing herein should be
 * constituting an additional warranty. Micro Focus shall not be liable for technical or editorial errors or omissions
 * contained herein.
 *
 * The information contained herein is subject to change without notice.
 */

import './MethodTile.scss';
import PropTypes from 'prop-types';
import React from 'react';
import t from '../../i18n/locale-keys';

export const TYPE_ADD = 'ADD';

export default function Tile({category, description, icon, iconTitle, id, isEnrolled, isFullyEnrolled, onClick, title, type}) {
    let className = 'ias-tile ias-large';
    if (type === TYPE_ADD) {
        className += ' opaque';
    }

    if (isEnrolled) {
        className += ' enrolled';
    }

    let cornerIcon = null;
    if (isFullyEnrolled) {
        cornerIcon = (
            <div className="ias-actions">
                <i className="ias-icon ias-icon-check_thick" title={t.authenticatorEnrolled()} />
            </div>
        );
    }

    const descriptionElement = description.length ? <p className="description">{description}</p> : null;
    const categoryElement = category.length ? <p className={'description'}>{category}</p> : null;

    return (
        <div className={className} id={id} onClick={onClick} tabIndex="0">
            <i className={'ias-icon ias-icon-' + icon} title={iconTitle} />
            <div className="ias-tile-content">
                <h3>{title}</h3>
                {descriptionElement}
                {categoryElement}
            </div>
            {cornerIcon}
        </div>
    );
}

Tile.propTypes = {
    category: PropTypes.string,
    description: PropTypes.string,
    icon: PropTypes.string.isRequired,
    iconTitle: PropTypes.string,
    id: PropTypes.string,
    isEnrolled: PropTypes.bool,
    isFullyEnrolled: PropTypes.bool,
    onClick: PropTypes.func,
    title: PropTypes.string.isRequired,
    type: PropTypes.string
};

Tile.defaultProps = {
    category: '',
    description: '',
    isEnrolled: false,
    isFullyEnrolled: false,
    onClick: (() => {})
};
